module.exports = __webpack_public_path__ + "media/assets/JingoLogoWhite-9b9d5de0b78c57463ae8f9c48f5075ee.png";